import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import { IndicadoresVivosService } from 'src/app/aplicaciones-modulos/indicadores-vivos/services/indicadores-vivos.service';
import { ConfiguracionTiposVariablesIncentivosService } from '../../services/configuracion-tipos-variables-incentivos.service';



@Component({
  selector: 'app-configuracion-tipos-variables-incentivos',
  templateUrl: './configuracion-tipos-variables-incentivos.component.html',
  styleUrls: ['./configuracion-tipos-variables-incentivos.component.css']
})
export class ConfiguracionTiposVariablesIncentivosComponent implements OnInit {

  tituloCard: string = 'Configuración de Tipos de Variables e Incentivos';
  tituloForm: string = 'Lista De Configuración de Tipos de Variables e Incentivos';

  formulario: FormGroup;
  formularioEstados: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstadosFiltro: any[] = [
    {
      clave: '',
      valor: 'TODOS'
    },
    {
      clave: '1',
      valor: 'ACTIVO'
    },
    {
      clave: '0',
      valor: 'INACTIVO'
    },
  ];

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbSiNo: any[] = [
    {
      clave: '1',
      valor: 'SI'
    },
    {
      clave: '0',
      valor: 'NO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _serviciosCRUD: ConfiguracionTiposVariablesIncentivosService,
  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idVariable: ['', null],
      descripcion: ['', [Validators.required, Validators.maxLength(100)]],
      tipoVariable: ['', [Validators.required]],
      tipoRecurso: ['', [Validators.required]],
      tipoMedida: ['', [Validators.required]],
      minimo: ['', [Validators.required, Validators.maxLength(3)]],
      maximo: ['', [Validators.required, Validators.maxLength(3)]],
      estado: ['', [Validators.required]],
      incentivoVehicular: ['', []],
    });

    this.formularioEstados = this.fb.group({
      estado: ['', [Validators.required]],
    });

    this.cargarGridcomponent();
    this.getTodo();
    this.getRecursos();
    this.getVariables();

    this.formulario.get('minimo').valueChanges
      .subscribe((resp) => {
        // this.getFormValidationErrors();
      });

    this.formulario.get('tipoRecurso').valueChanges
      .subscribe((resp) => {
        if (this.formulario.get('tipoVariable').value != 'DISTRIBUIDA') {
          this.getMedidas(resp);
        }
      });

    this.formulario.get('tipoVariable').valueChanges
      .subscribe((resp) => {

        this.tipoVariable(resp);

      });

    this.formularioEstados.get('estado').valueChanges
      .subscribe((resp) => {
        this.loading = true;
        this._serviciosCRUD.getTodoPorEstado(resp).subscribe((res: any[]) => {
          console.log("getTodoPorEstado()", res)
          this.loading = false;
          this.listaVacia = (res.length === 0) ? true : false;
          this.rowData = res;
        }, (err) => {
          this.loading = false;
          this.listaVacia = true;
          this.rowData = [];
        });
      });

    this.formularioEstados.get('estado').setValue('1');

  }

  /* FUNCIONES */
  tipoVariable(resp) {

    if (resp == 'DISTRIBUIDA') {
      this.cmbRecursosFiltered = [
        {
          clave: 'SELL_IN',
          valor: 'SELL_IN'
        },
      ];

      // this.getMedidas('SELL_IN');

      this.cmbMedidasFiltered = [
        {
          clave: 'META_VS_VENTAS_EN_DOLARES',
          valor: 'META_VS_VENTAS_EN_DOLARES',
        },
        {
          clave: 'META_VS_VENTAS_POR_CAJAS',
          valor: 'META_VS_VENTAS_POR_CAJAS',
        },
        {
          clave: 'META_VS_VENTAS_POR_KILOS',
          valor: 'META_VS_VENTAS_POR_KILOS',
        },
      ];

    }
    else {
      this.cmbRecursosFiltered = this.cmbRecursos;
      this.cmbMedidasFiltered = this.cmbMedidas;
    }

    if (resp == 'INCENTIVO') {
      this.formulario.get('tipoMedida').setValidators([]);
      this.formulario.get('tipoMedida').updateValueAndValidity();
    }
    else {
      this.formulario.get('tipoMedida').setValidators([Validators.required]);
      this.formulario.get('tipoMedida').updateValueAndValidity();
    }
    if (resp == 'INCENTIVO_VEHICULAR') {
      this.formulario.get('tipoMedida').setValidators([]);
      this.formulario.get('tipoMedida').updateValueAndValidity();
      this.formulario.get('tipoRecurso').setValidators([]);
      this.formulario.get('tipoRecurso').updateValueAndValidity();
    }
  }

  cmbRecursos = [];
  cmbRecursosFiltered = [];
  getRecursos() {
    this.loading = true;
    this._serviciosCRUD.getRecursos().subscribe((res: any[]) => {
      console.log("getRecursos()", res)
      this.loading = false;
      for (let i = 0; i < res.length; i++) {
        this.cmbRecursos.push({
          clave: res[i],
          valor: res[i]
        })
      }
      this.cmbRecursosFiltered = this.cmbRecursos;
      console.log("cmbRecursos", this.cmbRecursos)
    }, (err) => {
      this.loading = false;
      this.cmbRecursos = [];
    });
  }
  cmbVariables = [];
  getVariables() {
    this.loading = true;
    this._serviciosCRUD.getVariables().subscribe((res: any[]) => {
      console.log("getVariables()", res)
      this.loading = false;
      for (let i = 0; i < res.length; i++) {
        this.cmbVariables.push({
          clave: res[i],
          valor: res[i]
        })
      }
      console.log("cmbVariables", this.cmbVariables)
    }, (err) => {
      this.loading = false;
      this.cmbVariables = [];
    });
  }
  cmbMedidas = [];
  cmbMedidasFiltered = [];
  getMedidas(medida) {

    if (medida == null) return;

    this.cmbMedidas = [];
    this.cmbMedidasFiltered = [];
    this.loading = true;
    this._serviciosCRUD.getMedidas(medida).subscribe((res: any[]) => {
      console.log("getRecursos()", res)
      this.loading = false;
      this.cmbMedidas = [];
      this.cmbMedidasFiltered = [];
      for (let i = 0; i < res.length; i++) {
        this.cmbMedidas.push({
          clave: res[i],
          valor: res[i]
        })
      }
      this.cmbMedidasFiltered = this.cmbMedidas;
      console.log("cmbMedidas", this.cmbMedidas)
    }, (err) => {
      this.loading = false;
      this.cmbMedidas = [];
      this.cmbMedidasFiltered = [];
    });
  }

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idVariable',
        filter: true,
        sortable: true,
        width: 100,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Variable',
        field: 'descripcion',
        sortable: true,
        width: 350,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Tipo',
        field: 'tipoVariable',
        sortable: true,
        width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Recurso',
        field: 'tipoRecurso',
        sortable: true,
        width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Medida',
        field: 'tipoMedida',
        sortable: true,
        width: 350,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mínimo',
        field: 'minimo',
        sortable: true,
        width: 150,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Máximo',
        field: 'maximo',
        sortable: true,
        width: 150,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.formulario.reset();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Configuracion Tipos de Variables e Incentivos';
  }

  editar({ rowData }) {
    console.log("editar", rowData)
    this.formulario.reset();
    this.formulario.setValue(rowData);
    // this.getMedidas(rowData.tipoRecurso);
    // if (rowData.tipoVariable != 'DISTRIBUIDA') {
    //   this.getMedidas(rowData.tipoVariable);
    // }
    document.getElementById('buttonAbrirModal').click();
    this.tipoVariable(rowData.tipoVariable);
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Configuracion Tipos de Variables e Incentivos';
    this.tituloForm = 'Lista De Configuracion Tipos de Variables e Incentivos';
  }

  /** SERVICIOS */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodoPorEstado(this.formularioEstados.get('estado').value).subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
    console.log("eliminar", rowData)
    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._serviciosCRUD.delete(rowData.idVariable),
      })
      .then((res: any) => {
        this.getTodo();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();
    console.log("datos", datos);

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._serviciosCRUD.save(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTodo();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar")

    console.log(this.formulario.getRawValue())

    let data = this.formulario.getRawValue();

    if (data.tipoVariable == 'INCENTIVO') {
      data.tipoMedida = null;
    }

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.update(data),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTodo();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

}
